import styled from 'styled-components';

export const StyledWrapper = styled.div`
  width: 60px;
  height: 120px;
  background-color: #fff;
  position: absolute;
  z-index: 500;
  top: 8px;
  left: 0;
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
  display: flex;
  align-items: center;
  border-radius: 5px;
`;

export const StyledSliderContainer = styled.div`
  height: 100px;
`;